import React from 'react';
import {MediaPrivacy} from '../model/mediaDetails';
import {MediaPrivacyOptionModel} from '../model/mediaPrivacyOptionModel';
import {LibraryTypes} from '../constants/Constants';
import config from '../service/config';
import i18n from 'i18next';
import {Glyphs} from '@techsmith/tsc-cloud-style-guide';

export const getMediaPrivacyOptions = (mediaOwnerLibraryType: LibraryTypes) => {
   let publicTitle;
   let publicDescription;
   let privateTitle;
   let privateDescription;

   const privacyExtras = {
      organizationName: config.organizationName,
      applicationShortName: config.applicationShortName
   };

   if (mediaOwnerLibraryType === LibraryTypes.team) {
      publicTitle = i18n.t('privacy.media.public.team.title');
      publicDescription = i18n.t('privacy.media.public.team.description', privacyExtras);
      privateTitle = i18n.t('privacy.media.private.team.title');
      privateDescription = i18n.t('privacy.media.private.team.description');
   } else {
      publicTitle = i18n.t('privacy.media.public.singleuser.title');
      publicDescription = i18n.t('privacy.media.public.singleuser.description', privacyExtras);
      privateTitle = i18n.t('privacy.media.private.singleuser.title');
      privateDescription = i18n.t('privacy.media.private.singleuser.description');
   }

   const optionsMap = new Map<MediaPrivacy, MediaPrivacyOptionModel>();

   optionsMap.set(MediaPrivacy.public, {
      value: MediaPrivacy.public,
      label: publicTitle,
      subtext: publicDescription,
      glyph: <Glyphs.PrivacyLink16x16 />,
      disabled: false
   });

   optionsMap.set(MediaPrivacy.private, {
      value: MediaPrivacy.private,
      label: privateTitle,
      subtext: privateDescription,
      glyph: <Glyphs.Lock16x16 />,
      disabled: false
   });

   return optionsMap;
};
